import { Observable } from "rxjs";
import { getBALDataObservable } from './BALModel';
import { BALData } from '../../types';

export const getBALSolutionData = (): Observable<BALData> => getBALDataObservable();